const hstaff = [
  {
    text: "Staff Key",
    value: "staff_id"
  },
  {
    text: "First Name",
    value: "first_name"
  },
  {
    text: "Last Name",
    value: "last_name"
  },
  {
    text: "Action",
    value: "action",
    sortable: false,
    align: "center"
  }
];

const hstudent = [
  {
    text: "Student ID",
    value: "student_id"
  },
  {
    text: "First Name",
    value: "first_name"
  },
  {
    text: "Last Name",
    value: "last_name"
  },
  {
    text: "Action",
    value: "action",
    sortable: false,
    align: "center"
  }
];

const hvisitor = [
  {
    text: "Mobile",
    value: "mobile"
  },
  {
    text: "First Name",
    value: "first_name"
  },
  {
    text: "Last Name",
    value: "last_name"
  },
  {
    text: "Action",
    value: "action",
    sortable: false,
    align: "center"
  }
];

const hcontractor = [
  {
    text: "Mobile",
    value: "mobile"
  },
  {
    text: "First Name",
    value: "first_name"
  },
  {
    text: "Last Name",
    value: "last_name"
  },
  {
    text: "Action",
    value: "action",
    sortable: false,
    align: "center"
  }
];

export default {
  hstaff,
  hstudent,
  hvisitor,
  hcontractor
};
